
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { useEffect } from 'react'
import Header from './components/Header'
import Footer from './components/Footer'
import HomePage from './pages/HomePage'
import BlogPage from './pages/BlogPage'
import AboutPage from './pages/AboutPage'
import SearchPage from './pages/SearchPage'
import CategoryPage from './pages/CategoryPage'
import PostPage from './pages/PostPage'
import AdminDashboard from './pages/AdminDashboard'
import NotFound from './pages/NotFound'
import ErrorBoundary from './components/ErrorBoundary'
import { initGA } from './lib/analytics'
import { useAnalytics } from './hooks/use-analytics'

function AppRoutes() {
  // Track page views when routes change
  useAnalytics();
  
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Header />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={
            <ErrorBoundary>
              <HomePage />
            </ErrorBoundary>
          } />
          <Route path="/blog" element={
            <ErrorBoundary>
              <BlogPage />
            </ErrorBoundary>
          } />
          <Route path="/about" element={
            <ErrorBoundary>
              <AboutPage />
            </ErrorBoundary>
          } />
          <Route path="/search" element={
            <ErrorBoundary>
              <SearchPage />
            </ErrorBoundary>
          } />
          <Route path="/admin" element={
            <ErrorBoundary>
              <AdminDashboard />
            </ErrorBoundary>
          } />
          <Route path="/:categorySlug" element={
            <ErrorBoundary>
              <CategoryPage />
            </ErrorBoundary>
          } />
          <Route path="/:categorySlug/:postSlug" element={
            <ErrorBoundary>
              <PostPage />
            </ErrorBoundary>
          } />
          <Route path="*" element={
            <ErrorBoundary>
              <NotFound />
            </ErrorBoundary>
          } />
        </Routes>
      </main>
      <Footer />
    </div>
  )
}

function App() {
  // Initialize Google Analytics when app loads
  useEffect(() => {
    // Verify required environment variable is present
    if (!import.meta.env.VITE_GA_MEASUREMENT_ID) {
      console.warn('Missing required Google Analytics key: VITE_GA_MEASUREMENT_ID');
    } else {
      initGA();
    }
  }, []);

  return (
    <ErrorBoundary>
      <Router>
        <AppRoutes />
      </Router>
    </ErrorBoundary>
  )
}

export default App
